<div class="app-notifications-container">
  <div class="app-notification"
       *ngFor="let n of notifications"
       [ngClass]="n.type"
       (mouseenter)="pause(n)"
       (mouseleave)="resume(n)">
    <button class="close-btn" (click)="close(n.id)" aria-label="Cerrar">&times;</button>
    <div class="icon">
      <i class="bi" [ngClass]="icon(n)"></i>
    </div>
    <div class="content" [innerHTML]="n.message"></div>
    <div class="time-bar" *ngIf="n.autoClose">
      <!-- Barra simple (CSS controla animación) -->
      <div class="fill" [style.animationPlayState]="n.paused ? 'paused' : 'running'"></div>
    </div>
  </div>
</div>
